import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { GetWishlistDtoImpl } from '../../../../core/dto/wishlist/getwishlist/getwishlistdto';
import { GetWishlistResponse } from '../../../../core/api/wishlist/getwishlist/getwishlistresponse';
import { GetWishlistRequestImpl } from '../../../../core/api/wishlist/getwishlist/getwishlistrequest';
import { GetMusicBoxContentsDtoImpl } from '../../../../core/dto/musicboxcontents/getmusicboxcontentsdto';
import { GetMusicBoxContentsResponse } from '../../../../core/api/wishlist/getmusicboxcontents/getmusicboxcontentsresponse';
import { GetMusicBoxContentsRequestImpl } from '../../../../core/api/wishlist/getmusicboxcontents/getmusicboxcontentsrequest';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { DeleteToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/deletetone/deletetonedto';
import { DeleteToneResponse } from 'src/com/sixdee/crbtportal/core/api/tune/deletetone/deletetoneresponse';
import { DeleteToneRequestImpl } from 'src/com/sixdee/crbtportal/core/api/tune/deletetone/deletetonerequest';

export interface PlaylistDetailsAPIModel extends APIModel
{
    getPlaylist(playlistId: string): void;
    getPlaylistDetails(playlistId: string): void;
    deletePlaylist(toneDto: ToneDto): void;
}

export class PlaylistDetailsAPIModelImpl extends APIModelImpl implements PlaylistDetailsAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }

    deletePlaylist(toneDto: ToneDto): void 
  {
       /*  this.getAPIModelHandler().onSuccess("", 
            "", ""); */

      let deleteToneDto = new DeleteToneDtoImpl();
            deleteToneDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
            deleteToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
            deleteToneDto.setToneId(toneDto.getContentId().split("|")[0]);
            deleteToneDto.setPackName(this.getContext().getUserContext().getPackName());
   
            this.getAPIProcesssorFactory().getToneProcessorFactory()
            .getDelteTone()
            .success((deleteToneResponse: DeleteToneResponse)=>
            {
                this.getAPIModelHandler().onSuccess(deleteToneResponse.getAPIFeature(), 
                deleteToneResponse.getDescription(), deleteToneResponse);
              
             })
            .failure((deleteToneResponse: DeleteToneResponse)=>
             {
               this.getAPIModelHandler().onFailure(deleteToneResponse.getAPIFeature(), 
               deleteToneResponse.getDescription(), undefined);
             })
            .execute(new DeleteToneRequestImpl(deleteToneDto));
  }

    getPlaylist(playlistId: string): void
    {
        let getWishlistDto = new GetWishlistDtoImpl();
        getWishlistDto.setIdentifier("ViewWishListItems");
        getWishlistDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        getWishlistDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getWishlistDto.setWishlistType("2");

        this.getAPIProcesssorFactory().getToneProcessorFactory().getGetWishlist()
        .success((getWishlistResponse: GetWishlistResponse)=>
        {
            // let toneDto = this.getSelectedPlaylistFromList(playlistId, 
            //     getWishlistResponse.getGetWishlistDto().getWishlistToneDetailsList());

            // if(toneDto !== undefined)
            // {
                this.getPlaylistDetails(playlistId);
                getWishlistDto.setWishlistToneDetailsList(getWishlistResponse.getGetWishlistDto().getWishlistToneDetailsList());
    
                this.getAPIModelHandler().onSuccess(getWishlistResponse.getAPIFeature(), 
                getWishlistResponse.getDescription(), getWishlistDto.getWishlistToneDetailsList());
            // }
         })
        .failure((getWishlistResponse: GetWishlistResponse)=>
         {
           this.getAPIModelHandler().onFailure(getWishlistResponse.getAPIFeature(), 
           getWishlistResponse.getDescription(), undefined);
         })
        .execute(new GetWishlistRequestImpl(getWishlistDto));
    }

    getPlaylistDetails(playlistId: string): void
    {
        let getMusicBoxContentsDto = new GetMusicBoxContentsDtoImpl();
             getMusicBoxContentsDto.setToneCode(playlistId);
             getMusicBoxContentsDto.setLanguage(this.getContext().getUserContext().getLanguage());
             getMusicBoxContentsDto.setType("MB");
             getMusicBoxContentsDto.setPageNo("1");
             getMusicBoxContentsDto.setPerPageCount("20");
    
             this.getAPIProcesssorFactory().getToneProcessorFactory()
             .getMusicBoxContents()
             .success((getMusicBoxContentsResponse: GetMusicBoxContentsResponse)=>
             {
                 this.getAPIModelHandler().onSuccess(getMusicBoxContentsResponse.getAPIFeature(), 
                 getMusicBoxContentsResponse.getDescription(), getMusicBoxContentsResponse.getMusicBoxContentsDto()
                 .getListOfMusicBoxContentsTones());
               
              })
             .failure((getMusicBoxContentsResponse: GetMusicBoxContentsResponse)=>
              {
                this.getAPIModelHandler().onFailure(getMusicBoxContentsResponse.getAPIFeature(), 
                getMusicBoxContentsResponse.getDescription(), undefined);
              })
             .execute(new GetMusicBoxContentsRequestImpl(getMusicBoxContentsDto));
    }

    // getSelectedPlaylistFromList(playlistId: String, listOfCategories: ToneDto[]): number | boolean
    // {
    //    return listOfCategories.find((toneDto: ToneDto, index: number) => 
    //    {
    //         return toneDto.getContentId().split("|")[0] === playlistId ? index : false;
    //     });
    // }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/playlistdetails/playlistdetailsapimodel.ts